//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum JobOrderTaskPlannedRollingStockMode {
	None = 0,
	MergeInOneTask = 1,
	SplitInDifferentTask = 2
}
